export const types = {
  SET_MENU_SELECTION: '@/SET_MENU_SELECTION'
};
